import { Form } from "antd";
import useAuth from "../../hooks/useAuth";
import useLoading from "../../hooks/useLoading";

const useLogin = () => {
  const [form] = Form.useForm();
  const auth = useAuth();
  const loginLoading = useLoading();

  const handleLogin = async () => {
    loginLoading.start();
    const data = form.getFieldsValue();
    const { email, password } = data;
    await auth.handleLogin(email, password);
    loginLoading.stop();
  };

  return {
    form,
    handleLogin,
    loading: auth.userLoading,
    loginLoading,
  };
};

export default useLogin;
